if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.hideAlert = this.dataset.hideAlert === 'true';
        this.stopState = false;
        this.keepText = this.submitButton.getAttribute('data-keep-text') === 'true';
        this.dataset.productFormReady = 'true';
      }

      setCartActiveElementSafely(element = document.activeElement) {
        if (!this.cart || typeof this.cart.setActiveElement !== "function") return;
        this.cart.setActiveElement(element);
      }

      onSubmitHandler(event) {
        event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        const addOnProducts = this.closest('product-info')?.querySelector('add-on-products');
        let products = [];
        if (addOnProducts) {
          const addOnAfterAddBtn = this.submitButton && (this.submitButton.compareDocumentPosition(addOnProducts) & Node.DOCUMENT_POSITION_FOLLOWING) > 0;
          if (addOnAfterAddBtn) {
            this.addToCart();
            return;
          }
          if (addOnProducts.modal) {
            if (!addOnProducts.checkSimpleProducts()) {
              products = addOnProducts.allProducts();
              if (products.length > 0) {
                addOnProducts.openModal(this.submitButton);
                return;
              }
            }
          }
          products = addOnProducts.allProducts();
        } else {
          if (this.closest('complementary-product')) {
            let complementaryProduct = this.closest('complementary-product');
            let complementaryProducts = complementaryProduct.complementaryProducts;
            products = complementaryProducts.allProducts();
          }
        }
        if (products.length > 0) {
          this.addAllToCart(products);
        } else {
          this.addToCart();
        }
      }

      addToCart() {
        this.handleButton('adding');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections_url', window.location.pathname);
          //this.cart.setActiveElement(document.activeElement);
          this.setCartActiveElementSafely();
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: this,
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message
              });
              this.handleErrorMessage(response.message);
              this.handleButton('add');
              this.error = true;
              this.stopState = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: this,
                cartData: response,
                productVariantId: formData.get('id'),
                type: 'add'
              });
            }
            this.error = false;
            const quickModal = this.closest('modal-dialog') || this.closest('quick-add-modal') || this.closest('quick-view-modal');
            const quickDrawer = this.closest('side-drawer');
            const hotspotDrawer = this.closest('hotspot-component-drawer') || document.querySelector('hotspot-component-drawer.active');
            if (quickModal) quickModal.hide();
            if (quickDrawer) quickDrawer.close();
            if (hotspotDrawer) hotspotDrawer.close();
            if (this.cart.nodeName == 'CART-NOTIFICATION') {
              document.body.addEventListener('cartNotificationRendered', () => {
                setTimeout(() => this.cart.show());
              }, { once: true });
            } else if (this.cart.nodeName == 'CART-DRAWER') {
              document.body.addEventListener('cartRendered', () => {
                setTimeout(() => this.cart.open());
              }, { once: true });
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.handleButton('added', false);
          });
      }

      addAllToCart(items) {
        console.log('Adding bundle to cart:', items);
        this.cart = document.querySelector('cart-drawer');

        const mainId = this.form.querySelector('[name=id]').value;
        const qtyInput = this.form.querySelector('[name="quantity"]');
        const mainQty = Math.max(1, parseInt(qtyInput?.value || '1', 10));

        const normalizeId = (item) => String(item?.id ?? item).trim();
        const extraIds = [...new Set(items.map(normalizeId))].filter(
          (id) => id !== String(mainId)
        );

        const metaById = new Map();
        items.forEach((item) => {
          const id = String(item?.id || '').trim();
          if (!id) return;
          metaById.set(id, {
            productType: (item?.productType || '').trim()
          });
        });

        const mainMeta = {
          productType: (this.dataset.productType || '').trim()
        };
        metaById.set(String(mainId), {
          ...(metaById.get(String(mainId)) || {}),
          ...mainMeta
        });

        const buildItemPayload = (id, quantity) => ({ id, quantity });

        const products = {
          items: [
            buildItemPayload(mainId, mainQty),
            ...extraIds.map((id) => buildItemPayload(id, 1))
          ]
        };
        const bundleMetaItems = [mainId, ...extraIds].map((id, i) => ({
          id: String(id),
          quantity: i === 0 ? Number(mainQty) : 1,
          item_product_type: metaById.get(String(id))?.productType || '',
        }));

        this.handleButton('adding');

        let body;
        if (this.cart) {
          body = JSON.stringify({
            ...products,
            sections_url: window.location.pathname
          });
         // this.cart.setActiveElement(document.activeElement);
          this.setCartActiveElementSafely();
        } else {
          body = JSON.stringify(products);
        }

        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
          .then((response) => response.json())
          .then((response) => {
            if (response.errors) {
              this.handleErrorMessage(response.errors);
            }
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: this,
                errors: response.errors || response.description,
                message: response.message
              });
              this.handleErrorMessage(response.description);
              this.handleButton('add');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: this,
                cartData: response,
                type: 'bundle'
              });
              if (window.Shopify?.analytics?.publish) {
                window.Shopify.analytics.publish('forix:bundle_item_meta', {
                  items: bundleMetaItems
                });
              }
            }

            this.error = false;
            const quickModal =
              this.closest('modal-dialog') ||
              this.closest('quick-add-modal') ||
              this.closest('quick-view-modal');
            const quickDrawer = this.closest('side-drawer');
            const hotspotDrawer = this.closest('hotspot-component-drawer') || document.querySelector('hotspot-component-drawer.active');

            if (quickModal) quickModal.hide();
            if (quickDrawer) quickDrawer.close();
            if (hotspotDrawer) hotspotDrawer.close();

            document.body.addEventListener(
              'cartRendered',
              () => {
                setTimeout(() => this.cart.open());
              },
              { once: true }
            );
          })
          .catch(console.error)
          .finally(() => {
            this.handleButton('added', false);
          });
      }

      handleButton(state = 'adding', disabled = false) {
        if(this.stopState) return;
        const submitButtonText = this.submitButton.querySelector('span:not(.svg-wrapper)');
        switch (state) {
          case 'add':
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            submitButtonText.textContent = window.variantStrings.addToCart;
            break;
          case 'adding':
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            if (!this.keepText) {
              submitButtonText.textContent = window.variantStrings.addingToCart;
            }
            break;
          case 'added':
            this.submitButton.setAttribute('aria-disabled', true);
      
            if (disabled) {
              submitButtonText.textContent = window.variantStrings.soldOut;
            } else {
              if (!this.keepText) {
                submitButtonText.textContent = window.variantStrings.addedToCart;
              }
              setTimeout(() => {
                this.submitButton.classList.remove('loading');
                if (!this.keepText) {
                  submitButtonText.textContent = window.variantStrings.addToCart;
                }
                if (!this.error) {
                  this.submitButton.removeAttribute('aria-disabled');
                }
              }, 500);
            }
            break;
          default:
            break;
        }
      }

      handleSuccessMessage(successMessage = false) {
        if (this.hideAlert || successMessage == false) return;
        this.successAlert = this.successAlert || this.querySelector(`[id^="Alert-Success-"]`) || document.querySelector(`[id="Alert-Success"]`);
        if (!this.successAlert) return;
        this.successAlert.show(successMessage, { type: 'success', duration: ON_VISIBLE_DEBOUNCE_TIMER });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideAlert || errorMessage == false) return;
        this.errorAlert = this.errorAlert || this.querySelector(`[id^="Alert-Error-"]`) || document.querySelector(`[id="Alert-Error"]`);
        if (!this.errorAlert) return;
        this.errorAlert.show(errorMessage, { type: 'error', duration: ON_VISIBLE_DEBOUNCE_TIMER });
      }
    }
  );
}
